module.exports = __webpack_public_path__ + "static/img/function_3.ebc238e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/function_3.png
// module id = DOk6
// module chunks = 1